<template>
  <div id="resetpwd-container-confirm">
    <div class="resetpwd-inner">
      <div style="text-align:center; padding-bottom:40px; padding-top:40px;" class="top-part-notmobile">
        <img src="/static/logo.svg" style="max-width:200px;">
      </div>
      <div id="resetpwd-card">
        <div  id="" class="" v-if="!done">
          <h2 style="margin-top:20vh; margin-bottom:50px; text-align:center; font-size:22px;">
            CONFIRMA TU CAMBIO DE CONTRASEÑA
          </h2>
          <p>
            Introduce tu nueva clave
          </p>
          <div class="login-forms-container ">
            <b-field label="Contraseña"
            :type="type_pwd1"
            :message="msg_pwd1">
              <b-input placeholder="Password" ref="password1"
                  type="password"
                   v-model="inputs.password1" required password-reveal>
              </b-input>
            </b-field>
            <b-field label="Repite la contraseña"
            :type="type_pwd2"
            :message="msg_pwd2">
              <b-input placeholder="Password" ref="password2"
                  type="password"
                   v-model="inputs.password2" required password-reveal>
              </b-input>
            </b-field>

          <div class="login-button-container" >
            <a class="button is-fullwidth is-primary" :class="classLoading"  @click="resetPassword(inputs)" id="login-button">
              <span>Enviar</span>
            </a>
          </div>
        </div>

        <router-link class="button is-fullwidth" :to="{ name: 'Home'}">Volver</router-link>
      </div>
        <div v-else style="margin-top:20vh">
          <h2> Listo! Ahora puedes <router-link :to="{ name: 'login' }">Volver a hacer login en Programalaplaza</router-link> con tu nueva contraseña
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */

export default {
  name: "ResetPasswordConfirm",
  data: () => ({
    done: false,
    inputs: {
      password1: '',
      password2: ''
    },
    msg_pwd1:'',
    type_pwd1:'',
    msg_pwd2:'',
    type_pwd2:'',
    isLoading:false
  }),
  props: ['uid','token'],
  methods: {
      resetPassword ({ email }) {
        this.isLoading=true;
        if(this.ifFormValid()==false) {
          this.isLoading=false;
          return;
        }
        this.$store.dispatch('auth/resetPasswordConfirm', { 'uid': this.uid, 'token': this.token, 'new_password1': this.inputs.password1, 'new_password2': this.inputs.password2 } )
          .then(  r => {
            this.done=true
            this.isLoading=false;
          })
          .catch(error => {
            console.log(error.response)
            let error_msg= ' '
            for (var property in error.response.data) {
              if (error.response.data.hasOwnProperty(property)) {
                  error_msg += property + ':' + error.response.data[property]
              }
            }
            this.isLoading=false;
            this.type_pwd2="is-danger"
            this.msg_pwd2=error_msg
          })

        //this.$parent.close()
      },
      ifFormValid(){
        var isValid= ( this.$refs.password1.checkHtml5Validity() && this.$refs.password2.checkHtml5Validity() )
        return (isValid)
      },
      handleEnterKey(){
        this.resetPassword(this.inputs)
        this.$refs.emailField.$el.firstElementChild.blur();
      }
  },
  computed:{
    classLoading: function(){
      if(this.isLoading==true) return 'is-loading'
      else return ''
    }
  },
  created(){
  }
}
</script>
<style lang="less" >
@import (reference) "../../assets/styles/main.less";
/* only if it is embeded within the home */
#home-container input.input{
      border-bottom: 1px solid #ffffff;
      background-color: transparent!important;
      color: white;
}

#home-container .login-button{
background-color:white;
  &,span,i{
    color: @accentColor
  }
}

#login-forms-container{
  wdith:100%;
}

.login-button-container{
    text-align: center;
    padding: 40px 0;
}
.login-button{
  width:100%;
  height:52px;
  font-size: 22px;
  font-weight: 300;
  justify-content: space-between;
}
#home-container  .has-text-primary{
  color:white!important;
}
#login-button.is-loading span, #login-button.is-loading span i{
  color:white
}

#resetpwd-container-confirm{
background:  @accentColor;
  #resetpwd-card{
    background-color: #fff;
    padding:32px;
    padding-top:16px;
    padding-bottom:64px;
    border: 1px solid #9CAFB7;
    box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    flex:1;
    display: flex;
    min-height: 80vh;
    max-height: 800px;
    width:480px;
    margin:auto;
    background:  @accentColor;
  }

  #resetpwd-card > div{
    width:100%;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/Login/ResetPasswordConfirm.vue